var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "rgb(69, 110, 141)",
    height: "20px",
    width: "20px",
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3,22h1.5h23.1H29c0.6,0,1-0.4,1-1s-0.4-1-1-1h-1c-0.2-5.7-4.1-10.4-9.3-11.7C18.9,7.9,19,7.5,19,7c0-1.7-1.3-3-3-3 s-3,1.3-3,3c0,0.5,0.1,0.9,0.3,1.3C8.1,9.6,4.2,14.3,4,20H3c-0.6,0-1,0.4-1,1S2.4,22,3,22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5,24l0.8,1.5C6.4,25.8,6.8,26,7.2,26h17.7c0.4,0,0.7-0.2,0.9-0.5l0.8-1.5H5.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuFood);
export default __webpack_public_path__ + "static/media/menuFood.c873ecf3d35d8451456324e4cb80d5ab.svg";
export { ForwardRef as ReactComponent };